import React, {
  createContext,
  useEffect,
  useState,
  useContext,
  useCallback,
} from "react";
import { formats } from "./schema";
import $ from "jquery";
import { GrigoraDashboardContext } from "../dashboard/context";
import {
  emitOnInput,
  getRichtextsInSelection,
  getSelectedRangeHtml,
  getTextNodesIn,
  isMultipleRichTextSelected,
  replaceSelectedHtml,
  restoreSelectionFromNodeList,
  wrapAllChildrens,
} from "../dom";
import debounce from "debounce";

const GrigoraFormatsContext = createContext();

function nextNode(node) {
  if (node.hasChildNodes()) {
    return node.firstChild;
  } else {
    while (node && !node.nextSibling) {
      node = node.parentNode;
    }
    if (!node) {
      return null;
    }
    return node.nextSibling;
  }
}

function getFormatElementFromTarget(target, formats, format) {
  var parents = $(target).parentsUntil(
    ".grigora-richtext-input__field[contenteditable='true']",
  );

  var formatElement;
  parents.each(function (i) {
    if ($(this).is(formats[format].matchQuery)) {
      formatElement = $(this);
    }
  });

  return formatElement;
}

function getRangeSelectedNodes(range) {
  var node = range.startContainer;
  var endNode = range.endContainer;

  // Special case for a range that is contained within a single node
  if (node == endNode) {
    return [node];
  }

  // Iterate nodes until we hit the end container
  var rangeNodes = [];
  while (node && node != endNode) {
    rangeNodes.push((node = nextNode(node)));
  }

  // Add partially selected nodes at the start of the range
  node = range.startContainer;
  while (node && node != range.commonAncestorContainer) {
    rangeNodes.unshift(node);
    node = node.parentNode;
  }

  return rangeNodes;
}

function getSelectedNodes(selection) {
  var sel = selection;
  if (!sel.isCollapsed) {
    return getRangeSelectedNodes(sel.getRangeAt(0));
  }
  return [];
}
const GrigoraFormatsProvider = (props) => {
  const [activeFormats, setActiveFormats] = useState([]);
  const { editorDocument } = useContext(GrigoraDashboardContext) ?? {};

  const selectionActiveFormats = (event) => {
    const selection = editorDocument?.getSelection();

    if (!selection) {
      return;
    }

    if (selection.rangeCount === 0) {
      return;
    }

    const range = selection.getRangeAt(0);
    var activeFormatsTemp = [];
    // var selectedNodes = getSelectedNodes(selection, editorDocument);
    // console.log(selectedNodes);
    // if (selectedNodes.length > 1) {
    //   // Select all parents of all selected nodes
    //   let parentsSelectedNodes = selectedNodes.map(({ node }) => {
    //     if (node) {
    //       return $(node).parentsUntil(
    //         ".grigora-richtext-input__field[contenteditable='true']",
    //       );
    //     }
    //   });

    //   // Find common parents
    //   var parents = parentsSelectedNodes.shift()
    //     ? parentsSelectedNodes.shift().filter(function (v) {
    //         return parentsSelectedNodes.every(function (a) {
    //           return a.indexOf(v) !== -1;
    //         });
    //       })
    //     : [];
    // } else {
    var parents = $([
      range.commonAncestorContainer,
      ...$(range.commonAncestorContainer).parentsUntil(
        ".grigora-richtext-input__field[contenteditable='true']",
      ),
    ]);
    // }

    Object.keys(formats).forEach((format) => {
      // console.log("Checking format", format, parents, parents && parents.is && parents.is(formats[format].matchQuery));
      if (parents && parents.is && parents.is(formats[format].matchQuery)) {
        activeFormatsTemp.push(format);
      }
    });
    // console.log("Selection triggered", parents ,activeFormatsTemp, selection.anchorNode, selection.getRangeAt(0).cloneRange());
    setActiveFormats(activeFormatsTemp);
  };

  const checkFormatAppliedRTs = (format) => {
    const selection = editorDocument.getSelection();
    var range = selection.getRangeAt(0);

    function getActiveFormatsInRichTextSelection(element) {
      var activeFormatsTemp = false;
      var parents = $([
        element,
        ...$(element).parentsUntil(
          ".grigora-richtext-input__field[contenteditable='true']",
        ),
      ]);
      // }

      // console.log("Checking format", format, parents, parents && parents.is && parents.is(formats[format].matchQuery));
      if (parents && parents.is && parents.is(formats[format].matchQuery)) {
        return true;
      }

      return activeFormatsTemp;
    }

    var rangeOG = range.cloneRange();
    var richTexts = getRichtextsInSelection(selection);

    // Check in first rich text
    var allTextNodes = getTextNodesIn(richTexts[0]);
    range.setEnd(
      allTextNodes.at(-1) ?? richTexts[0],
      allTextNodes.at(-1)?.length ?? 0,
    );
    var isFirstActive = getActiveFormatsInRichTextSelection(
      range.commonAncestorContainer,
    );

    if (!isFirstActive) {
      // Restore Range
      selection.removeAllRanges();
      selection.addRange(rangeOG);
      return false;
    }

    // Check in last rich text
    var allTextNodes = getTextNodesIn(richTexts.at(-1));
    var range = rangeOG.cloneRange();
    range.setStart(allTextNodes[0], 0);
    var html = getSelectedRangeHtml(document, range);
    selection.removeAllRanges();
    selection.addRange(range);
    var isLastActive = getActiveFormatsInRichTextSelection(
      range.commonAncestorContainer,
    );

    if (!isLastActive) {
      // Restore Range
      selection.removeAllRanges();
      selection.addRange(rangeOG);
      return false;
    }

    // Check in between rich text
    // Use for loop so that we can exit early
    for (var i = 1; i < richTexts.length - 1; i++) {
      // If richtext is empty then continue
      if (richTexts[i].innerText === "") {
        continue;
      }

      // We query for format element and then check if it has sibling
      // If it has sibling then we can apply format
      var formatElement = richTexts[i].querySelector(
        formats[format].matchQuery,
      );
      if (!formatElement) {
        // Restore Range
        selection.removeAllRanges();
        selection.addRange(rangeOG);
        return false;
      }

      // Get parents till rich text and check if any of the parent has sibling
      var parents = $(formatElement).parentsUntil(
        ".grigora-richtext-input__field[contenteditable='true']",
      );
      var hasSibling = false;
      parents.each(function (i) {
        if ($(this).siblings().length > 0) {
          hasSibling = true;
        }
      });

      if (hasSibling) {
        // Restore Range
        selection.removeAllRanges();
        selection.addRange(rangeOG);
        return false;
      }
    }

    // Restore Range
    selection.removeAllRanges();
    selection.addRange(rangeOG);

    return true;
  };

  const applyFormat = useCallback(
    (format, formatProps, force = false) => {
      // if format not present in format store then return
      if (!(format in formats)) {
        return;
      }
      // If format is already applied reject the apply format request.
      if (activeFormats.includes(format) && !force) {
        return;
      }

      const selection = editorDocument.getSelection();

      // If multiple richtext is selected
      if (isMultipleRichTextSelected(selection)) {
        var range = selection.getRangeAt(0);
        var rangeOG = range.cloneRange();

        // Handle Multiple Select Differently Applying format for each RT
        const richTexts = getRichtextsInSelection(selection);

        // Check if we can actually apply format to all richtexts
        // If not then call remove format for all richtexts
        if (checkFormatAppliedRTs(format)) {
          removeFormat(format);
          return;
        }

        // Add Format in Base Node (First)
        var allTextNodes = getTextNodesIn(richTexts[0]);
        var range = selection.getRangeAt(0);
        range.setEnd(
          allTextNodes.at(-1) ?? richTexts[0],
          allTextNodes.at(-1)?.length ?? 0,
        );
        const topChilds = formats[format].applyFormat(
          formatProps,
          selection,
          editorDocument,
        );
        emitOnInput(richTexts[0]);

        // Add Format in Extend Node (Last)
        var allTextNodes = getTextNodesIn(richTexts.at(-1));
        var range = rangeOG.cloneRange();
        // console.log(allTextNodes, richTexts.at(-1));
        range.setStart(allTextNodes?.[0] ?? richTexts.at(-1), 0);
        var html = getSelectedRangeHtml(document, range);
        selection.removeAllRanges();
        selection.addRange(range);
        const lastChilds = formats[format].applyFormat(
          formatProps,
          selection,
          editorDocument,
        );
        emitOnInput(richTexts.at(-1));

        // Add Format in between Nodes
        richTexts.slice(1, -1).forEach((rtfields) => {
          formats[format].wrapFormat(rtfields, formatProps);
          emitOnInput(rtfields);
        });

        // Restore Selection For Nodes
        if (topChilds && lastChilds) {
          const rangeNew = document.createRange();
          rangeNew.setStart(topChilds.firstChild, 0);
          rangeNew.setEnd(lastChilds.lastChild, lastChilds.lastChild.length);
          selection.removeAllRanges();
          selection.addRange(rangeNew);
        }

        return;
      }

      // Check if selection is from richtext instance
      let anchorNode = selection.anchorNode;
      var currentEditableRichText;
      // If anchor node is of text type then get parent
      if (anchorNode.nodeType === 3) {
        anchorNode = anchorNode.parentElement;
      }

      currentEditableRichText = anchorNode?.closest(
        ".grigora-richtext-input__field[contenteditable='true']",
      );

      // is not within the contenteditable div
      if (!currentEditableRichText) {
        return;
      }
      // Apply Format
      formats[format].applyFormat(formatProps, selection, editorDocument);

      // Trigger OnInput event for richtext instance.
      emitOnInput(currentEditableRichText);

      // Add format to active formats since selection change is not triggered
      if (!activeFormats.includes(format)) {
        // console.log("Setting active formats", activeFormats, format);
        setActiveFormats([...activeFormats, format]);
      }
    },
    [editorDocument, activeFormats],
  );

  const getFormatProps = (format) => {
    // if format not present in format store then return
    if (!(format in formats)) {
      return;
    }

    const selection = editorDocument.getSelection();

    // If multiple richtext is selected
    if (isMultipleRichTextSelected(selection)) {
      return;
    }

    var currentEditableRichText = selection.anchorNode?.parentElement?.closest(
      ".grigora-richtext-input__field[contenteditable='true']",
    );

    // is not within the contenteditable div
    if (!currentEditableRichText) {
      return;
    }

    var parents = $(selection.anchorNode).parentsUntil(
      ".grigora-richtext-input__field[contenteditable='true']",
    );

    var formatElement;
    parents.each(function (i) {
      if ($(this).is(formats[format].matchQuery)) {
        formatElement = $(this);
      }
    });

    // no format element found
    if (!formatElement) {
      return;
    }

    if (formats[format].getFormatProps) {
      // If get format props function is present
      return formats[format].getFormatProps(formatElement, editorDocument);
    }

    return;
  };

  const updateFormat = (format, formatProps) => {
    // if format not present in format store then return
    if (!(format in formats)) {
      return;
    }

    const selection = editorDocument.getSelection();

    // If multiple richtext is selected
    if (isMultipleRichTextSelected(selection)) {
      return;
    }

    var currentEditableRichText = selection.anchorNode?.parentElement?.closest(
      ".grigora-richtext-input__field[contenteditable='true']",
    );

    // is not within the contenteditable div
    if (!currentEditableRichText) {
      return;
    }

    var parents = $(selection.anchorNode).parentsUntil(
      ".grigora-richtext-input__field[contenteditable='true']",
    );

    var formatElement;
    parents.each(function (i) {
      if ($(this).is(formats[format].matchQuery)) {
        formatElement = $(this);
      }
    });

    // no format element found
    if (!formatElement) {
      return;
    }

    if (formats[format].updateFormat) {
      // If get format props function is present
      formats[format].updateFormat(formatProps, formatElement, editorDocument);
      // Trigger OnInput event for richtext instance.
      emitOnInput(currentEditableRichText);
      return;
    }

    return;
  };

  const getFormatElement = (format) => {
    // if format not present in format store then return
    if (!(format in formats)) {
      return;
    }

    const selection = editorDocument.getSelection();

    // If multiple richtext is selected
    if (isMultipleRichTextSelected(selection)) {
      return;
    }

    var currentEditableRichText = selection.anchorNode?.parentElement?.closest(
      ".grigora-richtext-input__field[contenteditable='true']",
    );

    // is not within the contenteditable div
    if (!currentEditableRichText) {
      return;
    }

    var parents = $(selection.anchorNode).parentsUntil(
      ".grigora-richtext-input__field[contenteditable='true']",
    );

    var formatElement;
    parents.each(function (i) {
      if ($(this).is(formats[format].matchQuery)) {
        formatElement = $(this);
      }
    });

    // no format element found
    if (!formatElement) {
      return;
    }

    return formatElement;
  };

  const removeFormat = (
    format,
    formatProps,
    dontRemoveWithoutSelection = false,
  ) => {
    // if format not present in format store then return
    if (!(format in formats)) {
      return;
    }

    const selection = editorDocument.getSelection();

    // If multiple richtext is selected
    if (isMultipleRichTextSelected(selection)) {
      var range = selection.getRangeAt(0);
      var rangeOG = range.cloneRange();

      // Handle Multiple Select Differently Applying format for each RT
      const richTexts = getRichtextsInSelection(selection);

      // Add Format in Base Node (First)
      var allTextNodes = getTextNodesIn(richTexts[0]);
      var range = selection.getRangeAt(0);
      range.setEnd(allTextNodes.at(-1), allTextNodes.at(-1).length);
      var formatElement = getFormatElementFromTarget(
        range.startContainer,
        formats,
        format,
      );
      const topChilds = formats[format].removeFormat(
        formatProps,
        selection,
        formatElement,
        editorDocument,
        false,
      );
      emitOnInput(richTexts[0]);

      // Add Format in Extend Node (Last)
      var allTextNodes = getTextNodesIn(richTexts.at(-1));
      var range = rangeOG.cloneRange();
      range.setStart(allTextNodes[0], 0);
      var html = getSelectedRangeHtml(document, range);
      selection.removeAllRanges();
      selection.addRange(range);
      var formatElement = getFormatElementFromTarget(
        range.endContainer,
        formats,
        format,
      );
      const lastChilds = formats[format].removeFormat(
        formatProps,
        selection,
        formatElement,
        editorDocument,
      );
      emitOnInput(richTexts.at(-1));

      // Add Format in between Nodes
      richTexts.slice(1, -1).forEach((rtfields) => {
        formats[format].unWrapFormat(rtfields, formatProps);
        emitOnInput(rtfields);
      });

      // Restore Selection For Nodes
      if (topChilds && lastChilds) {
        restoreSelectionFromNodeList(editorDocument, selection, [
          topChilds.firstChild,
          lastChilds.lastChild,
        ]);
      }

      return;
    }

    var currentEditableRichText = selection.anchorNode?.parentElement.closest(
      ".grigora-richtext-input__field[contenteditable='true']",
    );

    // is not within the contenteditable div
    if (!currentEditableRichText) {
      return;
    }

    var parents = $(selection.anchorNode).parentsUntil(
      ".grigora-richtext-input__field[contenteditable='true']",
    );

    var formatElement;
    parents.each(function (i) {
      if ($(this).is(formats[format].matchQuery)) {
        formatElement = $(this);
      }
    });

    // no format element found
    if (!formatElement) {
      return;
    }

    // If no selection is made and dontRemoveWithoutSelection is true
    if (selection.toString() === "" && dontRemoveWithoutSelection) {
      return;
    }

    // Remove Format
    formats[format].removeFormat(
      formatProps,
      selection,
      formatElement,
      editorDocument,
    );

    // Trigger OnInput event for richtext instance.
    emitOnInput(currentEditableRichText);

    // Remove format from active formats since selection change is not triggered
    if (activeFormats.includes(format)) {
      // console.log("Setting active formats", activeFormats, format);
      setActiveFormats(activeFormats.filter((f) => f !== format));
    }
  };

  const debouncedSelectionActiveFormats = useCallback(
    debounce(() => {
      selectionActiveFormats();
    }, 300),
    [editorDocument],
  );

  useEffect(() => {
    editorDocument?.addEventListener(
      "selectionchange",
      debouncedSelectionActiveFormats,
    );
    return () => {
      editorDocument?.removeEventListener(
        "selectionchange",
        debouncedSelectionActiveFormats,
      );
    };
  }, [editorDocument]);

  return (
    <GrigoraFormatsContext.Provider
      value={{
        activeFormats,
        setActiveFormats,
        removeFormat,
        applyFormat,
        updateFormat,
        getFormatProps,
        getFormatElement,
      }}
    >
      {props.children}
    </GrigoraFormatsContext.Provider>
  );
};
export { GrigoraFormatsProvider, GrigoraFormatsContext };
